/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OAuthConnectDto } from '../../models/o-auth-connect-dto';
import { UserDto } from '../../models/user-dto';

export interface KakaoAuthControllerConnect$Params {
      body: OAuthConnectDto
}

export function kakaoAuthControllerConnect(http: HttpClient, rootUrl: string, params: KakaoAuthControllerConnect$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
  const rb = new RequestBuilder(rootUrl, kakaoAuthControllerConnect.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDto>;
    })
  );
}

kakaoAuthControllerConnect.PATH = '/api/oauth/kakao/connect';
